import React, { useState} from "react";
import {Box, Button, Chip, CircularProgress, Grid, Paper, Tab, Typography} from "@mui/material";
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AlunoInfPessoais from "./AlunoInfPessoais";
import {TabContext} from "@mui/lab";
import AlunoTabEnroll from "./AlunoTabEnroll";
import AlunoTabDocumentos from "./AlunoTabDocumentos";
import AlunoTabFinanceiro from "./AlunoTabFinanceiro";
import {iAluno} from "../../types/iAluno";
import { log } from "../../utils/log";
import {RootState} from "../../store/reducers";
import {useSelector} from "react-redux";


const sxStyles = {
    form: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 6,
        width: '100%',
    },
    paperGrid: {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'flex-start',
        flexWrap: 'wrap',
        width: '100%'
    },
    mainGrid: {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'flex-start',
        flexWrap: 'wrap',
    },
    cabecalhoGrid: {
        display: 'flex',
        margin: '2px',
        flexDirection: 'column'
    },
    botoesGrid: {
        display: 'flex',
        height: '40px',
        margin: '2px',
        flexDirection: 'row',
        justifyContent:  'flex-end'
    },
    fieldGrid: {
        padding: '6px',
    },
    buttonsGrid:{
        display: 'flex',
        flexDirection: 'row',
        justifyContent:  'flex-end'
    }
}



interface iAlunoDialog {
    isOpen: boolean,
    dialogState: (param:boolean) => void,

    recId?: number | null,
    registro?: iAluno
}

const AlunoDialog = (props: iAlunoDialog ) => {

    const [tabValue,setTabValue] =  useState<string>('1');
    const isFetchingAluno = useSelector( (state : RootState) => state.cadastros.isFetchingAluno )

    if (isFetchingAluno) {
     return (<React.Fragment>
         <CircularProgress/>
     </React.Fragment>)
    }

    const handleClose = () => {
        props.dialogState(false);
    };

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue)
    }

    const botoesDeAcao = () => {
        return (
            <React.Fragment>
                <Grid id={"gridTabs"} item  sx={{...sxStyles.botoesGrid}} xs={12} lg={12} xl={12}>
                     <Button onClick={handleClose}>FECHAR</Button>
                </Grid>
            </React.Fragment>
        )
    }

    log(2,"Aluno", props.recId, props.registro)

     const allPersonValues = props.registro;
    const rId = props.recId ?? 0;

    return (
        <React.Fragment>
                <Paper id={"paperForm"} sx={{...sxStyles.paperGrid }}>

                    <Grid id={"gridPaper"} container sx={{...sxStyles.mainGrid }} >
                        <Grid id={"gridCabecalho"}  container item sx={{...sxStyles.cabecalhoGrid }} xs={12} lg={12} xl={12}>
                            <Paper elevation={1} sx={{ p: 1.5, mb: 1 }}>
                                <Grid item container sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1}} lg={12} xl={12}>
                                      <Typography variant={"h5"}>{allPersonValues? allPersonValues.Name : ""}</Typography>
                                      <Chip label={`ID: ${allPersonValues? allPersonValues.id : ""}`} size="small" variant="outlined" />
                                </Grid>
                            </Paper>
                        </Grid>

                            {botoesDeAcao()}

                        <Grid id={"gridTabs"} item xs={12} lg={12} xl={12}>
                            <Paper>
                                <TabContext value={tabValue}>
                                    <Box>
                                        <TabList
                                            value={tabValue}
                                            onChange={handleTabChange}
                                            variant="scrollable"
                                            scrollButtons="auto"
                                            aria-label="scrollable auto tabs example"
                                        >
                                            <Tab label="DADOS PESSOAIS" value={"1"} />
                                            { (rId>0) && <Tab label="MATRICULAS" value={"2"}/> }
                                            { (rId>0) && <Tab label="DOCUMENTOS" value={"3"}/> }
                                            { (rId>0) && <Tab label="FINANCEIRO" value={"4"}/> }
                                        </TabList>
                                    </Box>

                                        <TabPanel value="1">
                                                <AlunoInfPessoais registro={props.registro}  />
                                        </TabPanel>
                                        <TabPanel value="2">
                                            <AlunoTabEnroll registro={allPersonValues}/>
                                        </TabPanel>

                                        <TabPanel value="3">
                                            <AlunoTabDocumentos registro={allPersonValues}/>
                                        </TabPanel>
                                        <TabPanel value="4">
                                            <AlunoTabFinanceiro registro={allPersonValues}/>
                                        </TabPanel>
                                </TabContext>
                            </Paper>

                        </Grid>

                        {botoesDeAcao()}

                    </Grid>

                </Paper>
        </React.Fragment>
    )
}


export default  (AlunoDialog);
